import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useAuth } from "./features/AuthContext";
import { Eye, EyeOff } from "lucide-react";

export default function Login() {
  const { login, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ username: "", password: "" });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    if (isAuthenticated) navigate("/", { replace: true });
  }, [isAuthenticated, navigate]);

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const validateForm = () => {
    let newErrors = {};
    if (!formData.username) newErrors.username = "Username is required";
    if (!formData.password) newErrors.password = "Password is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      setLoading(true);
      try {
        if (formData.username && formData.password) {
          //localStorage.setItem("userId", "admin");
          const response = await login(formData.username, formData.password);
          console.log("Login Login Response: ", response)
          const status = response.status;
          if (status === "success") {
            setSubmitted(true);
            setTimeout(() => navigate("/dashboard"), 500);
            const data = response.data;
            console.log("LoginData", data);
            localStorage.setItem("role", data?.Role);
          }

        } else {
          setErrors({ error: "Invalid Credentials" });
        }
      } catch (error) {
        setErrors({ error: "An error occurred. Please try again." });
      }
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-transparent flex items-center justify-center px-4 py-8">
      <div className="w-full max-w-md bg-slate-900 rounded-lg shadow-xl border border-slate-800 p-8 animate-fade-in">
        <div className="text-4xl mb-6 text-center">🔐</div>
        <h1 className="text-2xl font-bold text-white text-center mb-2">
          Login to Your Account
        </h1>
        <p className="text-sm text-slate-400 text-center mb-8">
          Enter your credentials to continue.
        </p>

        {errors.error && (
          <p className="text-red-500 text-sm text-center mb-4 bg-red-500/10 py-2 rounded border border-red-500/20">
            {errors.error}
          </p>
        )}
        {submitted && (
          <p className="text-green-500 text-sm text-center mb-4 bg-green-500/10 py-2 rounded border border-green-500/20">
            Login successful! Redirecting...
          </p>
        )}

        {!submitted && (
          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <label className="block text-sm font-medium text-slate-300 mb-1">Username</label>
              <input
                type="text"
                name="username"
                value={formData.username}
                onChange={handleChange}
                placeholder="Enter username"
                className="w-full bg-slate-950 text-white px-4 py-2.5 rounded-md border border-slate-800 placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent transition-all"
              />
              {errors.username && (
                <p className="text-red-500 text-xs mt-1">{errors.username}</p>
              )}
            </div>

            <div className="relative">
              <label className="block text-sm font-medium text-slate-300 mb-1">Password</label>
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                value={formData.password}
                onChange={handleChange}
                placeholder="Enter password"
                className="w-full bg-slate-950 text-white px-4 py-2.5 pr-10 rounded-md border border-slate-800 placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent transition-all"
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute right-3 top-9 text-slate-500 hover:text-white transition-colors"
              >
                {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
              </button>
              {errors.password && (
                <p className="text-red-500 text-xs mt-1">{errors.password}</p>
              )}
            </div>

            <button
              type="submit"
              className="w-full bg-blue-600 hover:bg-blue-500 text-white font-medium py-2.5 rounded-md shadow-lg shadow-blue-900/20 transition-all duration-200 mt-2"
            >
              {loading ? "Logging in..." : "Sign In"}
            </button>
          </form>
        )}

        <div className="text-xs text-slate-500 mt-8 text-center pt-4 border-t border-slate-800">
          © 2025 Smart Maheshwari
        </div>
      </div>
    </div>
  );
}
